import React from "react";
import ContentLoader from "react-content-loader" // Create skeleton here: https://skeletonreact.com/
import Chip from '@material-ui/core/Chip';

export function PortfolioCategories({ type = '', fetchingCategories = false, selected = '', categories = [], setFilter, isAuthorized = false, addNew }) {
    return (
        <>
            <div className="row">
                <div className="col-md-12 col-md-offset-3 col-md-pull-3">
                    {fetchingCategories && <div style={{ display: 'block' }}>
                        <ContentLoader
                            width={250}
                            height={32}
                            viewBox="0 0 250 32"
                            backgroundColor="var(--mn-shimmer-background)"
                            foregroundColor="var(--mn-shimmer-foreground)"
                        >
                            <rect x="0" y="0" rx="16" ry="16" width="120" height="32" />
                            <rect x="130" y="0" rx="16" ry="16" width="80" height="32" />
                        </ContentLoader>
                    </div>}
                    {(!fetchingCategories) && isAuthorized && <Chip
                        variant={"outlined"}
                        label={"Add new " + ((type === 'apps') ? 'App' : 'Design')}
                        color={"secondary"}
                        onClick={() => addNew()}
                        style={{ marginBottom: '10px', marginRight: '10px', fontFamily: 'roboto' }}
                    />}
                    {(!fetchingCategories) && <Chip
                        label={"All " + ((type === 'apps') ? 'Apps' : 'Designs')}
                        clickable={true}
                        color={selected === '' ? "secondary" : "default"}
                        onClick={() => setFilter('')}
                        style={{ marginBottom: '10px', marginRight: '10px', fontFamily: 'roboto' }}
                    />}
                    {(!fetchingCategories) && categories.map((f, i) => {
                        return (f.type === type) && <Chip
                            key={i}
                            label={f.name}
                            clickable={f.is_disabled === 0 ? true : false}
                            disabled={f.is_disabled === 1 ? true : false}
                            color={selected === f.hex ? "secondary" : "default"}
                            onClick={() => setFilter(f.hex)}
                            style={{ marginBottom: '10px', marginRight: '10px', fontFamily: 'roboto' }}
                        />
                    })}
                    {(!fetchingCategories) && <Chip
                        label={"Archived " + ((type === 'apps') ? 'Apps' : 'Designs')}
                        clickable={true}
                        color={selected === 'archived' ? "secondary" : "default"}
                        onClick={() => setFilter('archived')}
                        style={{ marginBottom: '10px', marginRight: '10px', fontFamily: 'roboto' }}
                    />}
                </div>
            </div>
        </>
    );
}
